import { Container, Sprite } from "pixi.js";
import { findInnerHole } from "../utils/findInnerHole.js";

/**
 * Декоративная рамка с прозрачным внутренним окном. fitInner подгоняет
 * масштаб так, чтобы внутреннее окно стало точно targetW × targetH.
 *
 * @param {Texture} texture
 * @param {object} [options]
 * @param {Renderer} [options.renderer] — для текстур из атласа (rotate/trim)
 * @param {{x,y,w,h}} [options.innerRect] — пропускает авто-сканирование
 * @param {number|{x:number,y:number}} [options.anchor=0] — pivot внутри окна
 */
export class ScalableFrame extends Container {
    constructor(texture, { renderer, innerRect, anchor = 0, alphaThreshold } = {}) {
        super();
        this._sprite = new Sprite(texture);
        this.addChild(this._sprite);
        this._innerRect = innerRect ?? null;
        this._anchor = typeof anchor === "number"
            ? { x: anchor, y: anchor }
            : { x: anchor.x ?? 0, y: anchor.y ?? 0 };
        this._ready = innerRect
            ? Promise.resolve(innerRect)
            : findInnerHole(texture, renderer, { alphaThreshold }).then((r) => {
                this._innerRect = r;
                return r;
            });
    }

    /** Подгоняет внутреннее окно рамки к targetW × targetH. */
    async fitInner(targetW, targetH, { uniform = false } = {}) {
        const r = this._innerRect ?? (await this._ready);
        const sx = targetW / r.w;
        const sy = targetH / r.h;
        const [scaleX, scaleY] = uniform ? [Math.max(sx, sy), Math.max(sx, sy)] : [sx, sy];

        this._sprite.scale.set(scaleX, scaleY);
        this._sprite.x = -r.x * scaleX;
        this._sprite.y = -r.y * scaleY;
        // (0,0) контейнера = top-left окна, (targetW, targetH) = bottom-right.
        this.pivot.set(targetW * this._anchor.x, targetH * this._anchor.y);

        return { scaleX, scaleY, innerRect: r };
    }
}
